export default __webpack_public_path__ + "static/media/stonechat.24c6ae96.jpg";